module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentOrganizationEvents) ? _c('div', [_c('ul', _vm._l((_vm.currentOrganizationEvents), function(e) {
    return _c('li', {
      key: e.eventId,
      staticClass: "list-item clickable",
      on: {
        "click": function($event) {
          _vm.chooseEvent(e)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(e.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.eventDateDisplay(e)))])])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189bbe74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/ChooseEventView.vue
// module id = 111
// module chunks = 0